import type { FormConfig } from '#types/config/components/form'

export default {
  cancelButtonVariant: 'primary'
} satisfies FormConfig['addAddress']
